import yup from '../../../config/yup';

export const selectValidationSchema = yup.object().shape({
  '@id': yup.string().default(''),
  '@data-type': yup.string().default('command'),
  type: yup.string().default('select'),
  action: yup.string().default('SELECT').required('Action is required'),
  command: yup
    .string()
    .default('SELECT')
    .required('Command is required')
    .matches(/^SELECT\s+\S+/i, "Command must start with 'SELECT' followed by at least one word"),
});
